var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('maps/layers/placeslayer',["require", "exports", "../../geo/latlng", "../../util/convert", "../icons", "./markerlayer"], function (require, exports, latlng_1, convert_1, icons_1, markerlayer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PlacesLayer = void 0;
    var PlacesLayer = /** @class */ (function (_super) {
        __extends(PlacesLayer, _super);
        function PlacesLayer(places) {
            var _this = this;
            var markers = places.map(function (place) {
                var altStr = convert_1.default.distance.localString(place.alt);
                return {
                    name: place.name,
                    lat: place.lat,
                    lng: place.lng,
                    icon: {
                        url: (0, icons_1.placeUrl)(place),
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    content: "          <strong>" + place.name + "</strong>\n          <div>" + [place.region, place.country].filter(function (_) { return _; }).join(", ") + "</div>\n          <div>Object type: " + place.objectType + "</div>\n          <div>" + (0, latlng_1.formatLatLng)(place) + "</div>\n          <div>" + (altStr && altStr + " MSL") + "</div>"
                };
            });
            _this = _super.call(this, markers) || this;
            return _this;
        }
        return PlacesLayer;
    }(markerlayer_1.MarkerLayer));
    exports.PlacesLayer = PlacesLayer;
});
//# sourceMappingURL=/assets/javascripts/maps/layers/placeslayer.js.map;
